// Splits a typed list of email addresses (commas, semicolons, spaces or new
// lines) into an array. The server trims, lower-cases, de-duplicates and
// validates (Survey#coach_emails=), so this only splits.
export function parseEmailList(text) {
  return (text || '').split(/[\s,;]+/).filter(Boolean);
}
